export default "__VITE_ASSET__BLa0twxe__"